import React, { useContext, useEffect, useState } from 'react';
import { Navbar, Container, Image } from 'react-bootstrap';
import 'components/navbar/navbar.scss';
import { LocaleContext } from 'routes/Router';
import 'assets/styles/common.scss';
import { Avatar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import LocalStorageManager from 'managers/LocalStorageManger';
import Shimmer from 'components/commom/Shimmer';
import { getProfileSectionData } from 'store/doctorProfileSection/doctorProfileSectionAction';
import CommonToast from 'components/commom/CommonToast';

const CustomNavbar = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [profileValue, setProfileValue] = useState('');

  const profileReducer = useSelector(
    (state) => state?.profileDataReducer?.loading
  );

  useEffect(() => {
    profileData();
  }, []);

  const profileData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProfileValue(res?.data);
        LocalStorageManager.setItem('doctorId', res?.data?.id);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {},
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getProfileSectionData(external));
  };

  return (
    <Navbar className={`d-flex ${locale === 'en' ? 'navbarEn' : 'navbarAr'}`}>
      <Container fluid>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <div
          className={`d-flex ${locale === 'en' ? 'ml-auto' : 'mr-auto'} items-center`}
        >
          <div
            className={`d-flex align-items-center ${locale === 'en' ? 'ms-4' : 'me-4'}`}
          >
            <Avatar className={locale === 'en' ? 'me-3' : 'ms-3'}>
              {profileValue?.profile_image !== '' ? (
                profileReducer ? (
                  <Shimmer width="88px" height="88px" borderRadius="50%" />
                ) : (
                  <Image src={profileValue?.profile_image} alt="icon" />
                )
              ) : (
                profileValue?.full_name
                  ?.split(' ')
                  .map((word) => word[0])
                  .join('')
                  .toUpperCase()
              )}
            </Avatar>
            <p
              className={`p-0 m-0 fs-14 fc-404040 family_outfit_semiBold_600 ${locale === 'en' ? 'me-4' : 'ms-4'}`}
            >
              {profileReducer ? (
                <Shimmer width="150px" height="20px" />
              ) : (
                profileValue?.full_name
              )}
            </p>
          </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
